var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csn-privacy-terms__links-holder"},[_c('app-link',{staticClass:"csn-privacy-terms__links",attrs:{"href":"https://csnradio.app/terms.html"}},[_vm._v("Terms of Service")]),_c('app-link',{staticClass:"csn-privacy-terms__links",attrs:{"href":"https://csnradio.app/privacy.html"}},[_vm._v("Privacy Policy")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }